import { createAction } from 'redux-actions';
import { PRODUCT_SELECTION_CLEAR_ERRORS } from '../constants';

export const clearErrors = createAction(PRODUCT_SELECTION_CLEAR_ERRORS);
